var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05667 0.723389L4 3.78006L0.943333 0.723389L0 1.66672L4 5.66672L8 1.66672L7.05667 0.723389Z",
    fill: "#737C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownArrow);
export default __webpack_public_path__ + "static/media/icon-dropdown-arrow.f003df3c9bfc7a7bd85e03c345a5c535.svg";
export { ForwardRef as ReactComponent };